export class Log {
    public static information(message: string) {
        const date = new Date();
        const value = `[${date.getFullYear()}-${date.getMonth()}-${date.getDate()}T${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}]`;

        console.log(`${value} ${message}`);
    }
    public static error(message: string, error: any[]) {
        const date = new Date();
        const value = `[${date.getFullYear()}-${date.getMonth()}-${date.getDate()}T${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}]`;

        console.error(`${value} Error:${message}`, error);
    }
}
